import { render } from "./ReportElektro.vue?vue&type=template&id=f8b13a30"
import script from "./ReportElektro.vue?vue&type=script&lang=js"
export * from "./ReportElektro.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportElektro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8b13a30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8b13a30', __exports__)) {
    console.log('reload')
    api.reload('f8b13a30', __exports__)
  }
  
  module.hot.accept("./ReportElektro.vue?vue&type=template&id=f8b13a30", () => {
    console.log('re-render')
    api.rerender('f8b13a30', render)
  })

}


export default __exports__